import { AlertCircle } from "lucide-react";
import { cn } from "@/lib/utils";
import { isStale } from "@/lib/freshness";

interface PropertyFreshnessBadgeProps {
  lastFreshnessConfirmedAt: string | null;
  staleDays: number;
  className?: string;
}

export function PropertyFreshnessBadge({
  lastFreshnessConfirmedAt,
  staleDays,
  className,
}: PropertyFreshnessBadgeProps) {
  if (!isStale(lastFreshnessConfirmedAt, staleDays)) return null;
  return (
    <span
      role="status"
      aria-label="Cần xác nhận tin còn"
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-warning-soft px-1.5 py-0.5 font-mono text-[11px] font-medium text-warning",
        className,
      )}
    >
      <AlertCircle aria-hidden="true" className="size-2.5" />
      Cần xác nhận
    </span>
  );
}
